interface PaymentError {
  code: string;
  title?: string;
  description?: string;
  additionalInfo?: {
    errorReason?: string;
    errorType?: string;
    detail?: string;
  };
}

interface ErrorMapping {
  message: string;
  title?: string;
}

const PAYMENT_ERROR_MAPPINGS: Record<string, (error: PaymentError) => ErrorMapping> = {
  "BNK-0313": (error: PaymentError) => {
    const errorReason = error.additionalInfo?.errorReason;
    
    if (errorReason === "key not found" || errorReason === "key not found for emv") {
      return {
        title: "Chave PIX não encontrada",
        message: "Não foi possível encontrar a chave PIX no QR Code informado. Verifique se o QR Code está correto e tente novamente.",
      };
    }
    
    return {
      title: "Erro no pagamento",
      message: error.description || "Pagamento do vendedor falhou. Tente novamente.",
    };
  },
  
  "BNK-0305": () => {
    return {
      title: "Valor inválido",
      message: "O valor do PIX informado é inválido ou não foi fornecido. Verifique o valor e tente novamente.",
    };
  },
  
  "BNK-0312": (error: PaymentError) => {
    const description = error.description || "";
    const limitMatch = description.match(/limite de:\s*([\d.]+)/i);
    
    let message = "O valor do pagamento ultrapassou o limite permitido.";
    
    if (limitMatch && limitMatch[1]) {
      const limitValue = parseFloat(limitMatch[1]);
      const formattedLimit = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(limitValue);
      
      message = `O valor do pagamento ultrapassou o limite de ${formattedLimit} para outras titularidades. Por favor, ajuste o valor e tente novamente.`;
    }
    
    return {
      title: "Limite ultrapassado",
      message,
    };
  },
};

const DEFAULT_ERROR_MESSAGE = "Houve um erro ao processar o pagamento. Tente novamente.";

export function getPaymentErrorMessages(error: any): ErrorMapping[] {
  if (!error?.response?.data?.errors || !Array.isArray(error.response.data.errors)) {
    return [{ message: DEFAULT_ERROR_MESSAGE }];
  }

  const errors = error.response.data.errors as PaymentError[];
  const messages: ErrorMapping[] = [];

  for (const err of errors) {
    const mappingFunction = PAYMENT_ERROR_MAPPINGS[err.code];
    
    if (mappingFunction) {
      messages.push(mappingFunction(err));
    } else {
      messages.push({
        title: err.title,
        message: err.description || DEFAULT_ERROR_MESSAGE,
      });
    }
  }

  if (messages.length === 0) {
    return [{ message: DEFAULT_ERROR_MESSAGE }];
  }

  return messages;
}

export function getPaymentErrorMessage(error: any): ErrorMapping {
  const messages = getPaymentErrorMessages(error);
  return messages[0];
}
